const PUBLIC_API = "public/v1";

export const URL_LIST_LOCATION = `${PUBLIC_API}/module/portal/locations`;
export const URL_GET_ALL_CITIES = `${PUBLIC_API}/all-cities`;
export const URL_GET_ALL_OFFICES = `${PUBLIC_API}/all-offices`;
export const URL_SUBMIT_LEADS = `${PUBLIC_API}/submit-leads`;

// Module
export const URL_LIST_LISTING = `${PUBLIC_API}/module/portal/properties`;
export const URL_SPECIFIC_OFFICE_LISTING = `${PUBLIC_API}/module/portal/offices/:slug/properties`;
export const URL_PROPERTY_CATEGORIES = `${PUBLIC_API}/module/portal/property-categories`;
export const URL_LISTING_IMAGES = `${PUBLIC_API}/module/portal/properties/:slug/property-images`;
export const URL_SIMILAR_LISTING = `${PUBLIC_API}/module/portal/properties/:slug/recommendations`;
export const URL_SIMILAR_LISTING_FOR_OFFICE = `${PUBLIC_API}/module/portal/properties/:slug/office-recommendations`;
export const URL_POST_CONTACT = `${PUBLIC_API}/module/portal/contact`;
export const URL_POST_SALE_RENT_PROPS = `${PUBLIC_API}/module/portal/sale-rent-form`;
export const URL_POST_JOIN = `${PUBLIC_API}/module/portal/marketing-applicants`;
export const URL_GET_DETAIL_OFFICE = `${PUBLIC_API}/module/portal/offices/:slug`;
export const URL_GET_LOCATION_OFFICES = `${PUBLIC_API}/module/portal/cities-with-offices`;
export const URL_GET_LOCATIONS = `${PUBLIC_API}/countries/1/provinces`;

// Article
export const URL_GET_ARTICLE_BANNER = `${PUBLIC_API}/article_banner`;
export const URL_GET_ARTICLE_DETAIL = `${PUBLIC_API}/article/:id`;
export const URL_GET_ARTICLE_LIST = `${PUBLIC_API}/article`;
export const URL_GET_ARTICLE_MORE = `${PUBLIC_API}/article_more/:id`;
export const URL_GET_ARTICLE_CATEGORY = `${PUBLIC_API}/article_category`;
